import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="card p-8 text-center max-w-md">
        <h1 className="text-3xl font-bold mb-2">404</h1>
        <p className="text-slate-500 mb-6">{t('errors.notFound')}</p>
        <Link to="/" className="btn-primary">
          {t('errors.goHome')}
        </Link>
      </div>
    </div>
  );
}
